const catagories = [
    {
        name: 'SAAS_PA',
        value: 'saas3'
    },
    {
        name: 'Startup',
        value: 'Volume1'
    },
    {
        name: 'SaaS',
        value: 'Volume3'
    },
    {
        name: 'Startup Handpicked',
        value: 'Volume2'
    },
    // {
    //     name: "Coding ",
    //     value: "Coding10"
    // },
    {
        name: 'Entrepreneurship',
        value: 'entrepreneurship2'
    },
    {
        name: 'Career',
        value: 'Volume4'
    },
    {
        name: 'Author',
        value: 'Volume5'
    },
    {
        name: 'Atomic Habits',
        value: 'Volume6'
    },
    {
        name: 'Tech (Frontend )',
        value: 'Volume7'
    },
    {
        name: 'Tech (Deployment)',
        value: 'Volume8'
    },
    {
        name: 'Stock market',
        value: 'Volume9'
    },
    //  ---moved to fitness
    // {
    //     name: "Diet",
    //     value: "Volume10"
    // },
    {
        name: 'Finance II',
        value: 'Volume11'
    },
    {
        name: 'Finance III',
        value: 'Volume12'
    },
    {
        name: 'AI',
        value: 'Volume13'
    },
    // {
    //     name: "Politics",
    //     value: "Volume14"
    // },
    {
        name: 'Engineering',
        value: 'Volume15'
    },
    {
        name: 'Naval',
        value: 'naval4'
    },
    {
        name: 'Inspiration',
        value: 'insp2'
    },
    {
        name: 'Improvement',
        value: 'improve2'
    },
    {
        name: 'Authors',
        value: 'authors1'
    },
    {
        name: 'Crypto & NFT',
        value: 'Crypto_NFT10'
    },
    {
        name: 'Design',
        value: 'Design10'
    },
    // move fitness to gym
    {
        name: 'Fitness',
        value: 'Volume10'
    },
    {
        name: 'Gym',
        value: 'Fitness10'
    },
    {
        name: 'Marketing',
        value: 'Marketing10'
    },
    {
        name: 'NoCode',
        value: 'NoCode10'
    },
    {
        name: 'Product Launched',
        value: 'Product_Launched10'
    },
    {
        name: 'Sales',
        value: 'Sales10'
    },
    {
        name: 'Startup Founders',
        value: 'Startup_Founders10'
    },
    {
        name: 'Startup Platforms',
        value: 'SaaS10'
    },
    {
        name: 'Crypto_All',
        value: 'crypto2'
    },
    {
        name: 'Biz',
        value: 'biz2'
    },
    {
        name: 'Finance',
        value: 'finance3'
    },
    {
        name: 'Writing',
        value: 'writing2'
    },
    {
        name: 'Programming',
        value: 'prog2'
    },
    {
        name: 'Advice',
        value: 'advice2'
    },
    {
        name: 'Tools',
        value: 'Tools10'
    },
    // {
    //     name: "US Politics",
    //     value: "US_politics10"
    // },
    // {
    //     name: "Web",
    //     value: "Web10"
    // },
    // ----------added on 3apr2022--------------
    {
        name: 'Hand Picked Tweets',
        value: 'handpicked'
    },
    {
        name: 'Startup Popular tweets',
        value: 'startup_pop'
    },
    {
        name: 'Popular Accounts',
        value: 'Popular1'
    }
];

export default catagories;
